(function ($) {
    $(window).load(function () {

		const swiper = new Swiper('.swiper', {
			slidesPerView : 1,
			spaceBetween : 10,
			loop: true,
			autoplay: {
				delay: 2000,
			},
			navigation : {
				nextEl : '.swiper-button-next',
				prevEl : '.swiper-button-prev',
			},
			breakpoints: {
				540: {
					slidesPerView: 2,
				},
				720: {
					slidesPerView: 4,
				},
			}
		});

    });
})(jQuery);
